// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__2144_","Div":"CustomFadeBox_Div__36izx","LargeDiv":"CustomFadeBox_LargeDiv__3Tdox"};